module.exports = __webpack_public_path__ + "img/9788932920696.d2afbf41.jpg";